<script lang="ts">
	import type { Snippet } from "svelte";
	import Icon from "./Icon.svelte";

	const {
		iconStart,
		iconEnd,
		children,
		iconSize = "medium",
	}: {
		iconStart?: string;
		iconEnd?: string;
		children?: Snippet;
		iconSize?: "small" | "medium";
	} = $props();

	const iconClass = iconSize === "small" ? "w-4 h-4 -mt-px" : "w-3 h-3 -mt-px md:w-6 md:h-6";
</script>

{#if iconStart}
	<Icon icon={iconStart} class={iconClass} />
{/if}

{#if children}
	{@render children()}
{/if}

{#if iconEnd}
	<Icon icon={iconEnd} class={iconClass} />
{/if}
